export class OverviewInfo {
    constructor(
        public id: string = null,
        public groupName: string = null,
        public address: string = null,
        public countryId: string = null,
        public countryName: string = null,
        public email: string = null,
        public contact: string = null,
        public phone: string = null,
        public description: string = null,
        public paymentTerm: string = null
    ) {
    }
}

export class MemberInfo {
    constructor(
        public patientREF: string = null,
        public name: string = null,
        public dateOfBirth: string = null
    ) { }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/group-template-information/overview-info.ts